import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IObservation } from '../../../message-models/observation.interface';
import { Observation, ObservationType, ObservationTypeString } from '../../../domain-model/observation.class';
import { IObservationSummary } from '../../../message-models/observation-summary.interface';
import { ObservationsService } from '../../services/observations.service';
import { consts } from '../../../common/modals/consts';
import { IAllowedOperations } from "../../../users/models/userInfo.interface";
import { EcaConfirmProcessService } from "../../../shared/services/eca-confirm-process.service";
import { EcaConfirmDeleteModalOptions } from "../../../shared/models/confirm-delete-modal-options.class";
import { ExportExcelService } from "../../../common/services/export-excel.service";
import { DatePipe } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { ObservationSummary } from '../../../domain-model/observation-summary';
import { Router } from '@angular/router';

@Component({
  selector: 'app-observations-list',
  templateUrl: './observations-list.component.html',
  styleUrls: ['./observations-list.component.scss']
})
export class ObservationsListComponent implements OnInit {
  @Input() observations: Array<IObservationSummary>;
  @Input() tableTitle: string = 'Observations';
  @Input() showCaption: boolean = true;
  @Input() showWarningMessage: boolean = true;
  @Input() companyId: string = consts.emptyGuid;
  @Input() allowedOperations: IAllowedOperations;
  @Input() addButtonText = 'Add';
  @Input() showAddButton: boolean = true;

  ObservationType: typeof ObservationType = ObservationType;
  ObservationTypeString: typeof ObservationTypeString = ObservationTypeString;
  @Output() viewObservationClicked: EventEmitter<IObservation> = new EventEmitter<IObservation>();
  @Output() createObservationClicked: EventEmitter<IObservation> = new EventEmitter<IObservation>();
  @Output() editObservationClicked: EventEmitter<IObservation> = new EventEmitter<IObservation>();
  columns: any[];
  exportColumns: any[];
  observationsLoading: boolean = false;
  isOnMobile: boolean = false;
  observationRecordSummariesToExport: any[] = [];
  rowMenuItems: MenuItem[];

  constructor(private observationsService: ObservationsService,
    private datePipe: DatePipe,
    private confirmProcessService: EcaConfirmProcessService,
    private exportExcelService: ExportExcelService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;

    this.columns = [{ field: 'observedBy', header: 'Observer', type: 'text' },
    { field: 'observedOn', header: 'Date Observed', type: 'date' },
    { field: 'followUpOn', header: 'Followup', type: 'date' },
    { field: 'observationTypeString', header: 'Type', type: 'text' },
    { field: 'summaryInfo', header: 'Information', type: 'text' },
    { field: 'notesAsHtml', header: 'Notes', type: 'html' },
    ];
    this.exportColumns = [{ field: 'observedBy', header: 'Observer' },
    { field: 'observedOn', header: 'Date Observed' },
    { field: 'followUpOn', header: 'Followup' },
    { field: 'observationType', header: 'Type' },
    { field: 'summaryInfo', header: 'Information' },
    { field: 'notesAsHtml', header: 'Notes' },
    ]

    this.rowMenuItems = [
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        visible: this.allowedOperations?.canDelete,
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.deleteObservation($event)
      }
    ]
  }

  // viewObservation(observationId: string) {
  //   this.viewObservationClicked.emit(observationId);
  // }


  createObservation() {
    const observation = new Observation({} as IObservation);
    this.createObservationClicked.emit(observation as IObservation);
  }

  deleteObservation(iObservationSummary?: IObservationSummary) {
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to delete the company observation made by ' + iObservationSummary.observedBy + '?',
      'Delete Company Observation?', new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.observationsLoading = true;
            this.observationsService.deleteObservation(iObservationSummary?.observationId, iObservationSummary?.observationType, this.companyId).subscribe(result => {
              if (result) {
                this.observations.forEach(x => {
                  if (x.observationId === iObservationSummary.observationId) {
                    this.observations = this.observations.filter(d => d.observationId !== iObservationSummary.observationId);
                  }
                })
                this.observationsLoading = false;
              }
            });
          }
        }
      });
  }

  
  viewObservation(iObservationSummary?: IObservationSummary) {
    let observationSummary = new ObservationSummary(iObservationSummary);
    this.router.navigate(["/observation-details/" + observationSummary.observationId])

  }

  //viewObservation(iObservationSummary?: IObservationSummary) {
  //  const observation = new Observation({
  //    id: iObservationSummary.observationId,
  //    summaryInfo: iObservationSummary.summaryInfo,
  //    notesAsHtml: iObservationSummary.notesAsHtml,
  //    observedBy: iObservationSummary.observedBy,
  //    observedOn: iObservationSummary.observedOn,
  //    followUpOn: iObservationSummary.followUpOn,
  //    observationType: iObservationSummary.observationType
  //  } as IObservation);
  //  this.viewObservationClicked.emit(observation as IObservation);
  //}

  editObservation(iObservationSummary?: IObservationSummary) {
    const observation = new Observation({
      id: iObservationSummary.observationId,
      summaryInfo: iObservationSummary.summaryInfo,
      notesAsHtml: iObservationSummary.notesAsHtml,
      observedBy: iObservationSummary.observedBy,
      observedOn: iObservationSummary.observedOn,
      followUpOn: iObservationSummary.followUpOn,
      observationType: iObservationSummary.observationType
    } as IObservation);
    this.editObservationClicked.emit(observation as IObservation);
  }
  exportToExcel() {
    this.observationRecordSummariesToExport = [];
    this.observations.forEach(element => {
      let temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = element.notesAsHtml;
      const tempObject = {
        observedBy: element.observedBy,
        observedOn: this.datePipe.transform(element.observedOn?.dateTime, 'dd/MM/yyyy'),
        followUpOn: this.datePipe.transform(element.followUpOn?.dateTime, 'dd/MM/yyyy'),
        observationType: ObservationType[element.observationType],
        summaryInfo: element.summaryInfo,
        notesAsHtml: temporalDivElement.textContent || temporalDivElement.innerText || ""
      };
      this.observationRecordSummariesToExport.push(tempObject);
    });

    this.exportExcelService.exportToExcel(this.observationRecordSummariesToExport, this.exportColumns, this.tableTitle.toString())

  }
}
